import React from "react"

import ValidatePhone from "./validate-phone"


const ValidatePhoneKyc = () => <ValidatePhone kyc />

export default ValidatePhoneKyc
